/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import BottomNavigation, { BottomNavigationAction } from 'material-ui/BottomNavigation';
import BuildIcon from 'material-ui-icons/Build';
import LayersIcon from 'material-ui-icons/Layers';
import ShowChartIcon from 'material-ui-icons/Timeline';
import { APP_DRAWER_WIDTH } from '../../../constants/globals';

const styles = theme => ({
  root: {
    position: 'fixed',
    bottom: 0,
    width: '100%'
  },
  [theme.breakpoints.up('lg')]: {
    root: {
      width: `calc(100% - ${APP_DRAWER_WIDTH}px)`,
    },
  }
});

const routes = [
  '/app/materials',
  '/app',
  '/app/simulations'
];

export class BottomNav extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event, index){
    const { history } = this.props;
    const route = routes[index];

    history.push(route);
  };

  render() {
    const { classes, path } = this.props;
    const index = routes.indexOf(path);

    return (
      <div className={classes.root}>
        <BottomNavigation value={index} onChange={this.handleChange} showLabels>
          <BottomNavigationAction label="Materials" icon={<LayersIcon />} />
          <BottomNavigationAction label="Stackup" icon={<BuildIcon />} />
          <BottomNavigationAction label="Impedance" icon={<ShowChartIcon />} />
        </BottomNavigation>
      </div>
    );
  }
}

BottomNav.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
};

export default withRouter(withStyles(styles)(BottomNav));



// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/BottomNav.jsx